import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    labelType: '',
    quantity: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('labelType', formData.labelType);
      formBody.append('quantity', formData.quantity);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6nv7l3lgirdouph2ic0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          labelType: '',
          quantity: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-0 rounded-3xl overflow-hidden shadow-2xl">
          {/* Sol Bilgi Alanı */}
          <div className="lg:col-span-2 bg-[#FF6B35] p-12 text-white">
            <h2 className="text-4xl font-bold mb-6">
              Hemen İletişime Geçin
            </h2>
            <p className="text-base text-white/90 mb-12 leading-relaxed">
              Uzman ekibimiz size en uygun profesyonel etiket baskı çözümünü sunmak için hazır. Hızlı etiket üretimi ve özel tasarım etiket hizmetlerimiz hakkında detaylı bilgi alın.
            </p>
            
            {/* İletişim Bilgileri */}
            <div className="space-y-6 mb-12">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <div className="space-y-1">
                  <div className="text-sm text-white/80 mb-1">Telefon</div>
                  <a href="tel:+902163658878" className="block text-base font-bold hover:text-white/80 transition-colors">
                    +90 216 365 88 78 <span className="text-white/70 font-normal text-sm">(Sabit)</span>
                  </a>
                  <a href="tel:+905326018294" className="block text-base font-bold hover:text-white/80 transition-colors">
                    +90 532 601 82 94 <span className="text-white/70 font-normal text-sm">(Mobil)</span>
                  </a>
                  <a href="tel:+905370207788" className="block text-base font-bold hover:text-white/80 transition-colors">
                    +90 537 020 77 88 <span className="text-white/70 font-normal text-sm">(Satış Destek)</span>
                  </a>
                  {/* WhatsApp Butonu */}
                  <a
                    href="https://wa.me/905326018294?text=Merhaba%2C%20etiket%20bask%C4%B1%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                    target="_blank"
                    rel="nofollow"
                    className="inline-flex items-center gap-2 mt-3 px-4 py-2 bg-[#25D366] text-white text-sm font-semibold rounded-full hover:bg-[#1ebe5d] transition-all duration-200 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#fff">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                    WhatsApp&apos;tan Yaz
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <div className="space-y-1">
                  <div className="text-sm text-white/80 mb-1">E-posta</div>
                  <a href="mailto:teklif@bioetiket.com" className="block text-sm font-semibold hover:text-white/80 transition-colors">
                    teklif@bioetiket.com
                  </a>
                  <a href="mailto:info@bioetiket.com" className="block text-sm font-semibold hover:text-white/80 transition-colors">
                    info@bioetiket.com
                  </a>
                  <a href="mailto:grafik@bioetiket.com" className="block text-sm font-semibold hover:text-white/80 transition-colors">
                    grafik@bioetiket.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl"></i>
                </div>
                <div>
                  <div className="text-sm text-white/80 mb-1">Adres</div>
                  <a
                    href="https://maps.google.com/?q=Yukarı+Dudullu+Mah.+Necip+Fazıl+Blv.+No:70+Ümraniye+İstanbul"
                    target="_blank"
                    rel="nofollow"
                    className="text-base leading-relaxed hover:text-white/80 transition-colors cursor-pointer"
                  >
                    Yukarı Dudullu Mah. Necip Fazıl Blv.<br />
                    No: 70, Ümraniye / İstanbul
                  </a>
                </div>
              </div>
            </div>
            
            {/* Çalışma Saatleri */}
            <div className="pt-8 border-t border-white/20">
              <h3 className="text-lg font-semibold mb-4">Çalışma Saatleri</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-white/80">Pazartesi - Cuma</span>
                  <span className="font-semibold">08:00 - 18:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white/80">Cumartesi</span>
                  <span className="font-semibold">09:00 - 14:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white/80">Pazar</span>
                  <span className="font-semibold">Kapalı</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Sağ Form Alanı */}
          <div className="lg:col-span-3 bg-white p-12">
            <h3 className="text-3xl font-bold text-[#1A2332] mb-2">
              Hızlı Teklif Formu
            </h3>
            <p className="text-sm text-gray-600 mb-8">
              Formu doldurun, 2 saat içinde size özel teklif hazırlayalım
            </p>
            
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              {/* Ad Soyad */}
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Ad Soyad *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all"
                  placeholder="Adınız ve soyadınız"
                />
              </div>
              
              {/* Email */}
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  E-posta *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all"
                  placeholder="ornek@email.com"
                />
              </div>
              
              {/* Telefon */}
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Telefon *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all"
                  placeholder="0555 555 55 55"
                />
              </div>
              
              {/* Etiket Türü */}
              <div>
                <label htmlFor="labelType" className="block text-sm font-medium text-gray-700 mb-2">
                  Etiket Türü *
                </label>
                <select
                  id="labelType"
                  name="labelType"
                  value={formData.labelType}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all cursor-pointer"
                >
                  <option value="">Seçiniz</option>
                  <option value="Gıda Etiketleri">Gıda Etiketleri</option>
                  <option value="Kozmetik Etiketleri">Kozmetik Etiketleri</option>
                  <option value="İlaç Etiketleri">İlaç Etiketleri</option>
                  <option value="Endüstriyel Etiketler">Endüstriyel Etiketler</option>
                  <option value="Güvenlik Etiketleri">Güvenlik Etiketleri</option>
                  <option value="Diğer">Diğer</option>
                </select>
              </div>
              
              {/* Adet */}
              <div>
                <label htmlFor="quantity" className="block text-sm font-medium text-gray-700 mb-2">
                  Tahmini Adet
                </label>
                <input
                  type="number"
                  id="quantity"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  min="1"
                  className="w-full px-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all"
                  placeholder="Örn: 1000"
                />
              </div>
              
              {/* Mesaj */}
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Mesajınız
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all resize-none"
                  placeholder="Projeniz hakkında detayları paylaşın... (Maksimum 500 karakter)"
                />
                <div className="text-xs text-gray-400 mt-1 text-right">
                  {formData.message.length}/500
                </div>
              </div>
              
              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-5 bg-[#FF6B35] text-white text-base font-semibold rounded-xl hover:bg-[#E55A2B] transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap flex items-center justify-center gap-2"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    Ücretsiz Teklif Al
                    <i className="ri-arrow-right-line text-xl"></i>
                  </>
                )}
              </button>
              
              {/* Status Messages */}
              {submitStatus === 'success' && (
                <div className="p-4 bg-green-50 border border-green-200 rounded-xl text-green-800 text-sm">
                  <i className="ri-checkbox-circle-line mr-2"></i>
                  Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-xl text-red-800 text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  Bir hata oluştu. Lütfen tekrar deneyin.
                </div>
              )}
              
              <p className="text-xs text-gray-500 italic text-center">
                <i className="ri-time-line mr-1"></i>
                Teklifiniz 2 saat içinde hazırlanacaktır
              </p>
            </form>
          </div>
        </div>

        {/* Google Haritalar */}
        <div className="mt-10 rounded-3xl overflow-hidden shadow-2xl w-full" style={{height: '420px'}}>
          <iframe
            title="Bioetiket Konum"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.5!2d29.1!3d41.03!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac5b0b0b0b0b1%3A0x0!2sYukar%C4%B1+Dudullu+Mah.+Necip+Faz%C4%B1l+Blv.+No%3A70+%C3%9Cmraniye+%C4%B0stanbul!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str&q=Yukarı+Dudullu+Mah.+Necip+Fazıl+Blv.+No:70+Ümraniye+İstanbul"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Adres Bilgi Bandı */}
        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 bg-[#FFF4EF] border border-[#FF6B35]/20 rounded-2xl px-8 py-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-map-pin-2-fill text-white text-lg"></i>
            </div>
            <div>
              <div className="text-xs text-gray-500 font-medium">Fabrika & Ofis Adresimiz</div>
              <div className="text-sm font-bold text-[#1A2332]">
                Yukarı Dudullu Mah. Necip Fazıl Blv. No: 70, Ümraniye / İstanbul
              </div>
            </div>
          </div>
          <a
            href="https://maps.google.com/?q=Yukarı+Dudullu+Mah.+Necip+Fazıl+Blv.+No:70+Ümraniye+İstanbul"
            target="_blank"
            rel="nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#FF6B35] text-white text-sm font-semibold rounded-full hover:bg-[#E55A2B] transition-all duration-200 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-navigation-line"></i>
            Yol Tarifi Al
          </a>
        </div>

      </div>
    </section>
  );
}